import { ReactElement } from 'react';

import { Translate, useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../../../../../translations';

import {
   DefaultConfidentialityModeUpdateFormBean,
   DefaultConfidentialityModeUpdateFormController,
} from './DefaultConfidentialityModeUpdateForm.types';
import { DefaultConfidentialityModeUpdateScopeField } from './fields/DefaultConfidentialityModeUpdateScopeField';

export type DefaultConfidentialityModeUpdateFormRenderProps = Pick<
   DefaultConfidentialityModeUpdateFormController,
   'handleSubmit' | 'formState' | 'watch'
>;

type DefaultConfidentialityModeUpdateFormProps = Readonly<{
   children: (renderProps: DefaultConfidentialityModeUpdateFormRenderProps) => ReactElement;
}>;

export const DefaultConfidentialityModeUpdateForm = (
   props: DefaultConfidentialityModeUpdateFormProps
): ReactElement => {
   const { register, handleSubmit, formState, watch } = useFormController<DefaultConfidentialityModeUpdateFormBean>({
      scope: 'ALL_DATA',
   });

   return (
      <StyledFlex direction={'column'} gap={'24px'}>
         <Translate>{practitionersTranslationKeys.defaultConfidentialResourceModeUpdate.scopeQuestion}</Translate>
         <DefaultConfidentialityModeUpdateScopeField register={register} />
         {props.children({ handleSubmit: handleSubmit, formState: formState, watch: watch })}
      </StyledFlex>
   );
};
